import { LISTING_HEADER_HEIGHT } from 'shared/styles/base';
// constants
export const IOOptions = { rootMargin: `-${LISTING_HEADER_HEIGHT}px 0px 0px 0px` };
export const APPROX_TOP = 160;
export const PRODUCT_WIDTH_HEIGHT_RATIO = 0.86576;
export const MINIMUM_PRODUCTS = 2;
export const MINIMUM_PRODUCTS_SCROLL_TO_TOP = 2;
export const NO_RESTULT_TEXT = 'No results found';
export const LOGIN_NUDGE = {
  DEFAULT_SESSION_TIME: 24,
  DEFAULT_TRIGGER: 12,
};
export const SCROLLTO_TOP_ICON_SIZE = '14px';
export const LOGIN_NUDGE_AB = 'login-nudge-plp';
